module.exports = __webpack_public_path__ + "static/img/share.c94fa4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share.png
// module id = 7/E+
// module chunks = 1